export default "__VITE_ASSET__BnFasgtd__"